import TextField from '@mui/material/TextField';
import { useAppDispatch } from '../../store/store';
import { useTranslation } from 'react-i18next';
import { Tooltip } from '@mui/material';

interface DynamicInputProps {
    columns: { name: string, type: string, value: any }[];
    name: string;
    type: string;
    index: number;
    onSave: (args: { name: string, value: string }) => void;
    disabled?: boolean,
    sx?: any
}

const DynamicInput = ({ columns, name, type, index, onSave, disabled = false, sx = undefined } : DynamicInputProps) => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();

    const handleChange = (event: any) => {
        var value = event.target.value;
        if(value) value = value.toString();
        
        dispatch(onSave({ name, value }));
    };

    const handleKeyPress = (event: any) => {
        if (type === 'int64') {
            const charCode = event.which ? event.which : event.keyCode;

            if (
                charCode !== 8 && 
                (charCode < 48 || charCode > 57)
            ) {
                event.preventDefault();
            }
        }
    };
    
    const handlePaste = (event: any) => {
        if (type === 'int64') {
            const paste = event.clipboardData.getData('text');
            if (!/^\d+$/.test(paste)) {
                event.preventDefault();
            }
        }
    };
    
    switch (type) {
        case 'int64':
            return (
                <Tooltip title={name} placement='top'>
                    <TextField
                        value={columns[index].value ?? ''}
                        label={name}
                        type="number"
                        inputProps={{ inputMode: 'numeric' }}
                        onChange={handleChange}
                        onKeyPress={handleKeyPress}
                        onPaste={handlePaste}
                        fullWidth
                        helperText={t(`${type}`)}
                        size="small"
                        disabled={disabled}
                        sx={sx}
                    />
                </Tooltip>
            );
        case 'float64':
            return (
                <Tooltip title={name} placement='top'>
                    <TextField
                        value={columns[index].value ?? ''}
                        label={name}
                        type="number"
                        inputProps={{ step: "any" }}
                        onChange={handleChange}
                        fullWidth
                        helperText={t(`${type}`)}
                        size="small"
                        disabled={disabled}
                        sx={sx}
                    />
                </Tooltip>
            );
        case 'object':
            return (
                <Tooltip title={name} placement='top'>
                    <TextField
                        value={columns[index].value ?? ''}
                        label={name}
                        type="text"
                        onChange={handleChange}
                        fullWidth
                        helperText={t(`${type}`)}
                        size="small"
                        disabled={disabled}
                        sx={sx}
                    />
                </Tooltip>
            );
        default:
            return null;
    }
};

export default DynamicInput;